import React from 'react'
import CustomerAuthForm from './components/CustomerAuthForm'
import { useLocation } from 'react-router-dom'
import Layout from '../home/theme/Layout'

export default function CustomerAuth() {
  const location = useLocation()
  const isRegister = location.pathname.includes('/cuenta/registro')

  return <Layout title={isRegister ? 'Crear cuenta' : 'Iniciar sesión'}>
    <div className="container">
      <div className="mt-5"></div>
      <CustomerAuthForm mode={isRegister ? 'register' : 'login'} />
    </div>
  </Layout>
}

